<template>
  <b-modal
    ref="modal-quickview"
    centered
    title="Vertrag QuickView"
    size="xl"
    ok-only
    ok-title="Schliessen"
    ok-variant="secondary"
    :no-close-on-backdrop="false"
    @hidden="onHidden"
  >
    <!-- Loading State -->
    <div
      v-if="isLoading"
      class="text-center py-5"
    >
      <b-spinner
        variant="primary"
        label="Laden..."
        style="width: 3rem; height: 3rem;"
      />
      <p class="mt-3 text-muted">
        Vertrag wird geladen...
      </p>
    </div>

    <!-- Error State -->
    <div
      v-else-if="errorMessage"
      class="text-center py-5"
    >
      <feather-icon
        icon="AlertCircleIcon"
        size="48"
        class="text-danger mb-2"
      />
      <h5 class="text-danger">
        Fehler beim Laden
      </h5>
      <p class="text-muted">
        {{ errorMessage }}
      </p>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="retryLoad"
      >
        <feather-icon
          icon="RefreshCwIcon"
          size="14"
        />
        Erneut versuchen
      </b-button>
    </div>

    <!-- PDF Display -->
    <div
      v-else-if="pdfBlobUrl"
      class="pdf-container"
    >
      <iframe
        :src="pdfBlobUrl"
        class="pdf-iframe"
        title="Vertrag PDF"
      />
    </div>

    <!-- Footer Actions -->
    <template
      v-if="pdfBlobUrl && !isLoading"
      #modal-footer="{ ok }"
    >
      <b-button
        variant="outline-primary"
        size="sm"
        @click="downloadPdf"
      >
        <feather-icon
          icon="DownloadIcon"
          size="14"
        />
        Download
      </b-button>
      <b-button
        variant="secondary"
        size="sm"
        @click="ok()"
      >
        Schliessen
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import zohoService from '@/service/zohoService'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
  },

  data() {
    return {
      isLoading: false,
      errorMessage: null,
      pdfBlobUrl: null,
      currentDocumentId: null,
    }
  },

  beforeDestroy() {
    this.cleanup()
  },

  methods: {
    show(documentId) {
      this.currentDocumentId = documentId
      this.errorMessage = null
      this.pdfBlobUrl = null
      this.$refs['modal-quickview'].show()
      this.loadPdf(documentId)
    },

    async loadPdf(documentId) {
      this.isLoading = true
      this.errorMessage = null

      try {
        const service = zohoService()
        const pdfBlob = await service.fetchDocumentPdf(documentId)

        if (this.pdfBlobUrl) {
          URL.revokeObjectURL(this.pdfBlobUrl)
        }

        this.pdfBlobUrl = URL.createObjectURL(pdfBlob)
      } catch (error) {
        this.errorMessage = error.message
          || 'Der Vertrag konnte nicht geladen werden. Bitte versuchen Sie es erneut.'
      } finally {
        this.isLoading = false
      }
    },

    retryLoad() {
      if (this.currentDocumentId) {
        this.loadPdf(this.currentDocumentId)
      }
    },

    downloadPdf() {
      if (!this.pdfBlobUrl) return

      const link = document.createElement('a')
      link.href = this.pdfBlobUrl
      link.download = `vertrag-${this.currentDocumentId}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    onHidden() {
      this.cleanup()
    },

    cleanup() {
      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl)
        this.pdfBlobUrl = null
      }
      this.currentDocumentId = null
      this.errorMessage = null
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.pdf-container {
  width: 100%;
  min-height: 70vh;
}

.pdf-iframe {
  width: 100%;
  height: 70vh;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
</style>
